import { gql, useMutation } from "@apollo/client"
import { Formik, Form } from "formik"
import * as Yup from "yup"
import { TRIM_TYPES, trimTextValue } from "../../components/FieldTypes/helpers/trimTextValue"

// Prime
import { InputText as Input } from "primereact/inputtext"
import { Button } from "primereact/button"

// Styles
import styles from "../../styles/Form.module.css"

// Context

const ADD_PARTICIPANT = gql`
  mutation AddParticipant(
    $participant_name_first: String!
    $participant_name_last: String!
    $participant_name_preferred: String
    $participant_phone_primary: String
    $participant_email_account: String
    $participant_city_primary: String
    $participant_state_primary: String
    $participant_zip_code_primary: String
    $organization: String
    $participant_membership_status: String
  ) {
    addParticipant(
      participant_name_first: $participant_name_first
      participant_name_last: $participant_name_last
      participant_name_preferred: $participant_name_preferred
      participant_phone_primary: $participant_phone_primary
      participant_email_account: $participant_email_account
      participant_city_primary: $participant_city_primary
      participant_state_primary: $participant_state_primary
      participant_zip_code_primary: $participant_zip_code_primary
      organization: $organization
      participant_membership_status: $participant_membership_status
    ) {
      participant_id
    }
  }
`

export default function ParticipantAdd() {
  const [addParticipant, { data, loading, error }] =
    useMutation(ADD_PARTICIPANT)

  const ParticipantSchema = Yup.object().shape({
    participant_name_first: Yup.string().required("Required"),
    participant_name_last: Yup.string().required("Required"),
    participant_name_preferred: Yup.string(),
    participant_phone_primary: Yup.string(),
    participant_email_account: Yup.string().email("Invalid email"),
    participant_city_primary: Yup.string(),
    participant_state_primary: Yup.string(),
    participant_zip_code_primary: Yup.string(),
  })

  return (
    <div>
      <h1>Add New Participant</h1>
      <Formik
        initialValues={{
          participant_name_first: "",
          participant_name_last: "",
          participant_name_preferred: "",
          participant_phone_primary: "",
          participant_email_account: "",
          participant_city_primary: "",
          participant_state_primary: "",
          participant_zip_code_primary: "",
          program_ids: [],
        }}
        validationSchema={ParticipantSchema}
        onSubmit={async (values) => {
          addParticipant({
            variables: {
              ...values,
            },
          })
        }}
      >
        {(formik) => {
          return (
            <Form className={styles.form}>
              <div className={styles.field}>
                <label className={styles.label}>Participant First Name:</label>
                <Input
                  name="participant_name_first"
                  onChange={(e) => formik.handleChange(trimTextValue(e))}
                  onBlur={formik.handleBlur}
                  className={styles.value}
                />
                {formik.touched.participant_name_first &&
                  formik.errors.participant_name_first && (
                    <div className={styles.errFieldMsg}>
                      {formik.errors.participant_name_first}
                    </div>
                  )}
              </div>

              <div className={styles.field}>
                <label className={styles.label}>Participant Last Name:</label>
                <Input
                  name="participant_name_last"
                  onChange={(e) => formik.handleChange(trimTextValue(e))}
                  onBlur={formik.handleBlur}
                  className={styles.value}
                />
                {formik.touched.participant_name_last &&
                  formik.errors.participant_name_last && (
                    <div className={styles.errFieldMsg}>
                      {formik.errors.participant_name_last}
                    </div>
                  )}
              </div>

              <div className={styles.field}>
                <label className={styles.label}>
                  Participant Name Preferred:
                </label>
                <Input
                  name="participant_name_preferred"
                  onChange={(e) => formik.handleChange(trimTextValue(e))}
                  onBlur={formik.handleBlur}
                  className={styles.value}
                />
                {formik.touched.participant_name_preferred &&
                  formik.errors.participant_name_preferred && (
                    <div className={styles.errFieldMsg}>
                      {formik.errors.participant_name_preferred}
                    </div>
                  )}
              </div>

              <div className={styles.field}>
                <label className={styles.label}>
                  Participant Phone Primary:
                </label>
                <Input
                  name="participant_phone_primary"
                  onChange={(e) => formik.handleChange(trimTextValue(e))}
                  onBlur={formik.handleBlur}
                  className={styles.value}
                />
                {formik.touched.participant_phone_primary &&
                  formik.errors.participant_phone_primary && (
                    <div className={styles.errFieldMsg}>
                      {formik.errors.participant_phone_primary}
                    </div>
                  )}
              </div>

              <div className={styles.field}>
                <label className={styles.label}>
                  Participant Email Primary:
                </label>
                <Input
                  name="participant_email_account"
                  onChange={(e) => formik.handleChange(trimTextValue(e, TRIM_TYPES.BOTH))}
                  onBlur={formik.handleBlur}
                  className={styles.value}
                />
                {formik.touched.participant_email_account &&
                  formik.errors.participant_email_account && (
                    <div className={styles.errFieldMsg}>
                      {formik.errors.participant_email_account}
                    </div>
                  )}
              </div>

              <div className={styles.field}>
                <label className={styles.label}>
                  Participant City Primary:
                </label>
                <Input
                  name="participant_city_primary"
                  onChange={(e) => formik.handleChange(trimTextValue(e))}
                  onBlur={formik.handleBlur}
                  className={styles.value}
                />
                {formik.touched.participant_city_primary &&
                  formik.errors.participant_city_primary && (
                    <div className={styles.errFieldMsg}>
                      {formik.errors.participant_city_primary}
                    </div>
                  )}
              </div>

              <div className={styles.field}>
                <label className={styles.label}>
                  Participant State Primary:
                </label>
                <Input
                  name="participant_state_primary"
                  onChange={(e) => formik.handleChange(trimTextValue(e))}
                  onBlur={formik.handleBlur}
                  className={styles.value}
                />
                {formik.touched.participant_state_primary &&
                  formik.errors.participant_state_primary && (
                    <div className={styles.errFieldMsg}>
                      {formik.errors.participant_state_primary}
                    </div>
                  )}
              </div>

              <div className={styles.field}>
                <label className={styles.label}>
                  Participant Zip Code Primary:
                </label>
                <Input
                  name="participant_zip_code_primary"
                  onChange={(e) => formik.handleChange(trimTextValue(e))}
                  onBlur={formik.handleBlur}
                  className={styles.value}
                />
                {formik.touched.participant_zip_code_primary &&
                  formik.errors.participant_zip_code_primary && (
                    <div className={styles.errFieldMsg}>
                      {formik.errors.participant_zip_code_primary}
                    </div>
                  )}
              </div>

              <div className={styles.field}>
                <label className={styles.label}>Programs:</label>
                <Input
                  name="program_ids"
                  onChange={(e) => formik.handleChange(trimTextValue(e))}
                  onBlur={formik.handleBlur}
                  className={styles.value}
                />
                {formik.touched.program_ids && formik.errors.program_ids && (
                  <div className={styles.errFieldMsg}>
                    {formik.errors.program_ids}
                  </div>
                )}
              </div>

              <Button
                label="Submit"
                icon="pi pi-check"
                loading={formik.isSubmitting}
                disabled
                type="submit"
                className={styles.submitButton}
              />
            </Form>
          )
        }}
      </Formik>
    </div>
  )
}
